const PayrollBanner = ({
  heading = "Just Need HRMS Software? We Have A Dedicated Page",
  description = "Waggex HRMS Software helps you manage payroll, attendance, leaves, employees, shifts, and payslips from one simple platform.",
  buttonText = "View HRMS Software",
  buttonLink = "https://app.waggex.com/signup",
}) => {
  return (
    <section className="w-full bg-[#F6F9FB] px-6 py-10">
      <div className="max-w-6xl mx-auto text-center mt-4 mb-4">
        <h2 className="text-[#10324F] text-xl sm:text-3xl font-roboto font-bold uppercase">
          {heading}
        </h2>

        <p className="mt-4 text-[#10324F] text-sm sm:text-base">
          {description}
        </p>

        <button
          className="mt-6 bg-[#10324F] text-white py-3 px-6 rounded-xl text-sm sm:text-lg shadow-lg hover:scale-[1.02] transition"
          onClick={() => (window.location.href = buttonLink)}
        >
          {buttonText}
        </button>
      </div>
    </section>
  );
};

export default PayrollBanner;
